export enum PayableType {
  TRUST = 'trust',
  ESCROW = 'escrow',
  OTHER = 'other'
}

export const PAYABLE_TYPE_LABELS: Record<PayableType, string> = {
  [PayableType.TRUST]: 'Trust',
  [PayableType.ESCROW]: 'Escrow',
  [PayableType.OTHER]: 'Other'
}

/** IOLTA / Trust bank account sort code */
export const TRUST_BANK_SORT_CODE = '1031'
/** Escrow bank account sort code */
export const ESCROW_BANK_SORT_CODE = '1035'
/** GL account sort code for Trust/Escrow payable */
export const PAYABLE_GL_SORT_CODE = '2100'
/** Operating bank account sort code */
export const OPERATING_BANK_SORT_CODE = '1036'
